module.exports = __webpack_public_path__ + "img/pricing-Illustration.ef667188.svg";